import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/observable';

import { Meetup } from '../models/meetup';

@Injectable()
export class MeetupService {

	constructor(private afDatabase: AngularFireDatabase) { }

	public getMeetups(): Observable<Meetup[]> {
		return this.afDatabase.list('/meetups');
	}

	public getNextMeetups(): Observable<Meetup[]> {
		const date = new Date();

		return this.afDatabase.list('/meetups', {
			query: {
				orderByChild: 'startsAt',
				startAt: date.getTime()
			}
		});
	}

	public getMeetup(key: string): Observable<Meetup> {
		return this.afDatabase.object(`/meetups/${key}`);
	}

	public async addMeetup(meetup: Meetup): Promise<string> {
		const date = new Date();
		meetup.createdAt = date.getTime();
		meetup.updatedAt = date.getTime();

		return this.afDatabase.list('/meetups').push(meetup).then(res => {
			return res;
		});
	}

	public async updateMeetup(key: string, meetup: Meetup): Promise<any>  {
		const date = new Date();
		meetup.updatedAt = date.getTime();

		return this.afDatabase.object(`/meetups/${key}`).update(meetup) as Promise<any>;
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/services/meetup.service.ts